export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
export const phoneRegex = /^(?:\+?\d{1,3}[- ]?)?(?!0{10})\d{10}$/;
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
export const numberRegex = /^[0-9]+$/;
export const cannotStartWithSpace = /^[^\s].*$/
export const nameRegex = /^[A-Za-z]+$/;
export const nonZeroValues = /^(?!0+$)\d+$/;
export const fullNameRegex = /^[A-Za-z]+(?:\s[A-Za-z]+)*$/;
export const floatNumberRegex = /^(?!0\d)\d{1,10}(\.\d{1,2})?$/;
export const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
export const UANRegex = /^[0-9]{12}$/;
export const ESIRegex = /^[0-9]{10,17}$/;
export const pfRegex = /^[A-Z]{2}\/[A-Z]{3,4}\/[0-9]{6,7}\/[0-9]{3,7}$/;


